import { Divider, Typography } from '@mui/material'
import React from 'react'
import ReportAppIssuseWrap from '../../../../Components/Molecules/Help/ReportAppIssuse/ReportAppIssuseWrap'
import { withTranslation } from 'react-i18next'

function ReportAppIssuseTemplate({t}) {
  return (
    <>
        <Typography component="h1" style={{ fontWeight: "bold", fontSize: "30px", marginBlock: "1rem", textTransform: "capitalize" }}>
          {t("help.help")}
        </Typography>
        <Divider />
        <ReportAppIssuseWrap /> 
    </>
  )
}

export default withTranslation()(ReportAppIssuseTemplate)